export default function(id, oldQuestions) {
  return {
    profileQuestions: oldQuestions.filter(item => item.id !== id)
  }
}
